import Folder from '../packages/folder'
import FolderItem from '../packages/folder-item'
import Header from '../packages/header'
import Footer from '../packages/footer'
import Main from '../packages/main'
import SlideAside from '../packages/slide-aside'
import Container from '../packages/container'
import ContainerSlide from '../packages/container-slide'
import Cell from '../packages/cell'
import CellGroup from '../packages/cell-group'
import CellSlide from '../packages/cell-slide'
import CellExpand from '../packages/cell-expand'
import Button from '../packages/button'
import Radio from '../packages/radio'
import RadioGroup from '../packages/radio-group'
import Checkbox from '../packages/checkbox'
import CheckboxGroup from '../packages/checkbox-group'
import Switch from '../packages/switch'
import Input from '../packages/input'
import Textarea from '../packages/textarea'
import Popup from '../packages/popup'
import PopupPicker from '../packages/popup-picker'
import PopupPickerOption from '../packages/popup-picker-option'
import MessageComponent from '../packages/message'
import Message from '../packages/message/src/main.js'
import DialogComponent from '../packages/dialog'
import Dialog from '../packages/dialog/src/main.js'
import Tab from '../packages/tab'
import TabPanel from '../packages/tab-panel'
import Form from '../packages/form'
import FormItem from '../packages/form-item'
import PullRefresh from '../packages/pull-refresh'
import List from '../packages/list'
import ListItem from '../packages/list-item'
import CoverBox from '../packages/cover-box'
import DateTimePicker from '../packages/date-time-picker'
import ButtonExpand from '../packages/button-expand'
import Divider from '../packages/divider'
import Card from '../packages/card'

const version = '0.0.1';
const install = function(Vue, config = {}) {
    if (install.installed) return;

    Vue.component(Folder.name, Folder);
    Vue.component(FolderItem.name, FolderItem);
    Vue.component(Header.name, Header);
    Vue.component(Footer.name, Footer);
    Vue.component(Main.name, Main);
    Vue.component(SlideAside.name, SlideAside);
    Vue.component(Container.name, Container);
    Vue.component(ContainerSlide.name, ContainerSlide);
    Vue.component(Cell.name, Cell);
    Vue.component(CellGroup.name, CellGroup);
    Vue.component(CellSlide.name, CellSlide);
    Vue.component(CellExpand.name, CellExpand);
    Vue.component(Button.name, Button);
    Vue.component(Radio.name, Radio);
    Vue.component(RadioGroup.name, RadioGroup);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(CheckboxGroup.name, CheckboxGroup);
    Vue.component(Switch.name, Switch);
    Vue.component(Input.name, Input);
    Vue.component(Textarea.name, Textarea);
    Vue.component(Popup.name, Popup);
    Vue.component(PopupPicker.name, PopupPicker);
    Vue.component(PopupPickerOption.name, PopupPickerOption);
    Vue.component(MessageComponent.name, MessageComponent);
    Vue.component(DialogComponent.name, DialogComponent);
    Vue.component(Tab.name, Tab);
    Vue.component(TabPanel.name, TabPanel);
    Vue.component(Form.name, Form);
    Vue.component(FormItem.name, FormItem);
    Vue.component(PullRefresh.name, PullRefresh);
    Vue.component(List.name, List);
    Vue.component(ListItem.name, ListItem);
    Vue.component(CoverBox.name, CoverBox);
    Vue.component(DateTimePicker.name, DateTimePicker);
    Vue.component(ButtonExpand.name, ButtonExpand);
    Vue.component(Divider.name, Divider);
    Vue.component(Card.name, Card);

    Vue.prototype.$message = Message
    Vue.prototype.$dialog = Dialog
    Vue.prototype.$confirm = Dialog.confirm
    Vue.prototype.$prompt = Dialog._prompt

    Vue.directive('focus', function(el) {
        el.querySelector('input').focus()
    })
    Vue.directive('loading', {
        update : function(el, binding) {
            if(binding.value === false) {
                let dom = el.querySelector('.pp-loading__wrap');

                el.classList.remove("pp-loading__parent");
                el.classList.remove("pp-loading__parent--relative");
                
                dom && el.removeChild(dom)
            }
            else if(binding.value === true 
                && !el.classList.value.match('pp-loading__parent')) {
                let dom = document.createElement('div');
                let elPosition = getComputedStyle(el).position;

                if(elPosition !== 'fixed' || elPosition !== 'absolute') {
                    el.classList.add("pp-loading__parent");
                }
                else {
                    el.classList.add("pp-loading__parent--relative");
                }

                dom.setAttribute('class', 'pp-loading__wrap')
                dom.innerHTML = `<div class="pp-loading">
                                    <svg class="pp-loading__svg" viewBox="0 0 100 100">
                                    <circle class="pp-loading__circle" cx="50" cy="50" r="30" fill="transparent" stroke-width="3"></circle>
                                    </svg>
                                </div>`
                el.appendChild(dom)
            }
        }
    })
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
};

export default {
    install,
    version,
    Folder,
    FolderItem,
    Header,
    Footer,
    Main,
    SlideAside,
    Container,
    ContainerSlide,
    Cell,
    CellGroup,
    CellSlide,
    CellExpand,
    Button,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Switch,
    Input,
    Textarea,
    Popup,
    PopupPicker,
    PopupPickerOption,
    Message,
    MessageComponent,
    Dialog,
    DialogComponent,
    Tab,
    TabPanel,
    Form,
    FormItem,
    PullRefresh,
    List,
    ListItem,
    CoverBox,
    DateTimePicker,
    ButtonExpand,
    Divider,
    Card,
};
